import * as React from "react";

import { AppShape, HurdleShape } from "@eave/shared/types/api";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import LoanDetails from "./LoanDetails";
import CriticalDetails from "./CriticalDetails";
import Summary from "./Summary";

interface HurdleEditorProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class UnderwritingSummaryHurdleEditor extends React.Component<HurdleEditorProps, any> {
  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <LoanDetails app={app} />
        <CriticalDetails app={app} />
        <Summary app={app} />
      </HurdleView>
    );
  }
}

export default UnderwritingSummaryHurdleEditor;
